/* eslint-disable import/prefer-default-export */

const COMPLIANCE_CHECKBOX_FIELD_IDS = new Set(['IsConsentProvided', 'IsTCsRead']);

function fieldElementId(fieldName) {
  return fieldName.replace('.', '_');
}

function appendComplianceCheckboxSummaryItem(list, elementId, field, message) {
  const liClass = 'at-mt-0 at-mb-1 at-font__body2';
  const linkClass = 'at-link at-link__text';
  const href = `#${elementId}`;
  const bannerPrefix = field.attr('data-banner-prefix');
  const bannerLinkText = field.attr('data-banner-link-text') || message;

  if (bannerPrefix) {
    list.append(`<li class="${liClass}">${bannerPrefix}<a class="${linkClass}" href="${href}">${bannerLinkText}</a></li>`);
    return;
  }

  list.append(`<li class="${liClass}"><a class="${linkClass}" href="${href}">${bannerLinkText}</a></li>`);
}

/**
 * Appends validation summary list items for Community Connect concession forms.
 * Compliance checkboxes use banner prefix + link text (not field display name).
 */
export function appendCommunityConnectValidationSummaryItems(list, errorMap) {
  $.each(errorMap, (fieldName, message) => {
    const elementId = fieldElementId(fieldName);
    const field = $(`#${elementId}`);
    const displayName = field.attr('data-display-name');
    const liClass = 'at-mt-0 at-mb-1 at-font__body2';
    const linkClass = 'at-link at-link__text';
    const isComplianceCheckbox = field.attr('type') === 'checkbox'
      || COMPLIANCE_CHECKBOX_FIELD_IDS.has(fieldName);

    if (isComplianceCheckbox) {
      appendComplianceCheckboxSummaryItem(list, elementId, field, message);
      return;
    }

    const errorMessage = message.replace(`The field ${displayName}`, '').replace(displayName, '');
    list.append(`<li class="${liClass}"><a class="${linkClass}" href="#${elementId}">${displayName}</a>${errorMessage}</li>`);
  });
}
